import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../app/rootReducer";
import { resolveDashboard2AvailablePlaceQuickActions } from "../utils/dashboard2-secondary-place-quick-action.utils";

const selectUserInformation = (state: RootState) => state.login.userInformation;

export const selectDashboard2PlaceQuickActions = createSelector(
  selectUserInformation,
  userInformation => {
    if (!userInformation) {
      return [];
    }

    const { placeTypes, zoneTypes, visitorManagementEnabled, company } = userInformation;
    const licensedPlaceTypes = placeTypes ?? [];

    return resolveDashboard2AvailablePlaceQuickActions(
      company.meta,
      licensedPlaceTypes,
      zoneTypes ?? [],
      {
        placeTypeIds: new Set(licensedPlaceTypes.map(placeType => placeType.id)),
        zoneTypeIds: new Set(zoneTypes?.map(zoneType => zoneType.id) ?? []),
        visitorManagementEnabled
      }
    );
  }
);
